import { Component, ElementRef, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { fromEvent, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ProcessDataSource } from 'src/app/services/process.datasource';
import { ProcessService } from 'src/app/services/process.service';
import { SharedService } from 'src/app/services/sharedService';
import { ConfirmationDialogComponent } from '../dialogs/confirmation-dialog/confirmation-dialog.component';
import { TaxPayerService } from 'src/app/services/taxPayer.service';

@Component({
  selector: 'app-recurring-reports',
  templateUrl: './recurring-reports.component.html',
  styleUrls: ['./recurring-reports.component.css']
})
export class RecurringReportsComponent implements OnInit {
  displayedColumns: string[] = ['open','name', 'key', 'type', 'rec_num', 'status', 'action'];
  
  @Input() company: any;
  dataSource: ProcessDataSource;
  subscriptionSaveRecurringChange: any 
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('input', { static: false }) input: ElementRef;
  constructor(public dialog: MatDialog, private processService: ProcessService,
    private sharedService: SharedService, public taxPayerService: TaxPayerService) { }

  ngOnInit() {
    this.dataSource = new ProcessDataSource(this.processService)
    setTimeout(() => {
      this.dataSource.loadRecurringProcesses('{"tin":"' + this.company.tin + '"}', 'asc', 'name', 0, this.paginator.pageSize);
      this.setupEventHandlers();
    }, 1000)
  }

  setupEventHandlers() {
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0;

          this.loadRecurringProcessPage();
        })
      )
      .subscribe();

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadRecurringProcessPage())
      )
      .subscribe();
  }
  async toggleRecursion(element, status){
    element.rec_status = status
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, { 
      width: '500px', 
      data: { text: "DIALOG.REMOVE_RECURSION", emitter: null, obj: element, action:"CONFIRM", showComment: true  } 
    }); 
    this.subscriptionSaveRecurringChange = this.sharedService.confirmDialogEmitter.subscribe(val => { 
      if (val) { 
        this.processService.toggleRecursion(element, status).subscribe(val => {
          this.loadRecurringProcessPage() 
        })
        let saveData = {
          "type": val['rec_status'] === 'SUSPENDED' ? 'RECURSION_STOPPED' : 'RECURSION_RESTARTED',
          "tin": this.company.tin,
          "companyName": this.company.name,
          "comment": val['comment'],
          "municipalityId": this.company.municipality['id'],
          "municipalityName": this.company.municipality['name'],
          "details":{
              'name': val['name'],
              'key': val['key'],
              'rec_num': val['rec_num'],
              'month': val['month']
            }
        }
        this.taxPayerService.saveNotificationData(saveData).subscribe(saveDeletion=>{})
      } 
    }) 
    dialogRef.afterClosed().subscribe(result => { 
      this.subscriptionSaveRecurringChange.unsubscribe()
    }); 
  }
  loadRecurringProcessPage() {
    this.dataSource.loadRecurringProcesses(
      '{"query":"' + this.input.nativeElement.value + '" , "tin":"' + this.company.tin + '"}',
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize);
  }
  removeRecursionEmmitter: EventEmitter<boolean> = new EventEmitter(); 
  subscriptionConfirm: any 
  async openRemoveRecursionDialog(element) { 
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, { 
      width: '500px', 
      data: { text: "DIALOG.REMOVE_RECURSION", emitter: this.removeRecursionEmmitter, obj: element, action:"CONFIRM", showComment: true  } 
    }); 
    this.subscriptionConfirm = this.sharedService.confirmDialogEmitter.subscribe(val => { 
      if (val) { 
        this.processService.toggleRecursion(val, 'REMOVED').subscribe(val => {
          this.loadRecurringProcessPage() 
        })
        let saveDeletion = {
            "type": 'RECURSION_DELETE',
            "tin": this.company.tin,
            "companyName": this.company.name,
            "comment": val['comment'],
            "municipalityId": this.company.municipality['id'],
            "municipalityName": this.company.municipality['name'],
            "details":{
              'name': val['name'],
              'key': val['key'],
              'rec_num': val['rec_num'],
              'month': val['month']
            }
          }
        this.taxPayerService.saveNotificationData(saveDeletion).subscribe(saveDeletion=>{})
      } 
    }) 
 
    dialogRef.afterClosed().subscribe(result => { 
      this.subscriptionConfirm.unsubscribe()
    }); 
  } 
  
}
